<!--
  * @Author: jh 1758579481@qq.com
  * @Date: 2021/2/1
-->
<template>
</template>

<script>
  export default {
    name: "login",
    data() {
      return {}
    },
    created() {
      // let APP_ID = 'wx92c083c8c7c385d2' //湖南三棵树信息科技有限公司
      // let APP_ID = 'wx31d07d486d0c324e' //丰顺县中医院
      // let APP_ID = 'wxf860f9a188831d8d' //丰顺县第二人民医院
      // let APP_ID = 'wx168bcba7a10a3a24' //丰顺县妇保院
      // let APP_ID = 'wx40b1b80b95a64ec6' //蕉岭县中医院
      let APP_ID = 'wxeb051addcb5ae524' //蕉岭县妇幼保健院
      let redirect = location.protocol + '//' + location.host + '#/oauth'
      let authURI = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + APP_ID + '&redirect_uri=' + encodeURIComponent(redirect) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
      window.location.replace(authURI)
    },
    methods: {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/login.vue